import React, { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import Table from '@awp/components/table';
import { Link } from 'react-router-dom';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { Row, Col, Card, Button, Spinner, Container } from 'react-bootstrap';
import { Views, Permissions, FORM_MODE } from '@awp/constants';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import Authorize from '@awp/components/Authorize';
import { ActionMenuLinkEdit, ActionMenuLinkView, ActionMenuView } from '@awp/components/Common/AwpActionMenus';
import { Crud } from '@awp/shared/Crud';

const SensorAssociatedModelTable = ({
  isMedium,
  isLarge,
  sensormodelData,
  sensorData,
  loading,
  setMode,
  searchSensor,
  setSearchSensor,
  filteredSensorData,
  setFilteredSensorData,
}) => {
  const crud = new Crud(`Associated Equipment for ${sensormodelData.ManufacturerName} ${sensormodelData.ModelNumber}`);

  const actionMenu = (row) => {
    return (
      <>
        <div>
          <Authorize requires={[Permissions.WriteSensorEquipment]}>
            <ActionMenuLinkEdit link={Views.SensorEquipment} linkId={row.row.original.Id} stateMode={FORM_MODE.EDIT} />
          </Authorize>
          <ActionMenuLinkView link={Views.SensorEquipment} linkId={row.row.original.Id} stateMode={FORM_MODE.VIEW} />
        </div>
      </>
    );
  };
  const hasSearch = (src) => {
    return src ? src.toLowerCase().includes(searchSensor.toLowerCase()) : false;
  };
  useEffect(() => {
    let filtered = [...sensorData];
    if (!isValueEmpty(searchSensor)) {
      filtered = filtered.filter(
        (sensor) =>
          hasSearch(sensor.Manufacturer) || //here is the name of manufacturer
          hasSearch(sensor.ModelNumber) ||
          hasSearch(sensor.ModelId + '') ||
          hasSearch(sensor.FirmwareVersion) ||
          hasSearch(sensor.SerialNumber) ||
          hasSearch(sensor.SensorTypeName) ||
          hasSearch(sensor.Id + '') ||
          (sensor.WeatherStation && !isValueEmpty(sensor.WeatherStation.Name)
            ? hasSearch(sensor.WeatherStation.Name)
            : false) ||
          (sensor.WeatherStation && !isValueEmpty(sensor.WeatherStation.Number)
            ? hasSearch(sensor.WeatherStation.Number)
            : false),
      );
    }

    setFilteredSensorData(filtered);
  }, [searchSensor]);
  const cellComponentWs = (p) => {
    return (
      <>
        {p.value && p.value.Id ? (
          <Link to={Views.WeatherStation} state={{ id: p.value.Id, mode: FORM_MODE.VIEW }}>
            {p.value.Number + ' - ' + p.value.Name}
          </Link>
        ) : (
          ''
        )}
      </>
    );
  };
  const columns = React.useMemo(
    () => [
      {
        Header: 'ID',
        accessor: 'Id',
      },
      {
        Header: 'Serial number',
        accessor: 'SerialNumber',
        show: isMedium,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Firmware version',
        accessor: 'FirmwareVersion',
        show: isLarge,
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Weather station',
        accessor: 'WeatherStation',
        show: isLarge,
        sortType: (rowA, rowB, id) => {
          let valA = '';
          let valB = '';

          if (rowA.original[id] && rowA.original[id].Number) {
            valA = rowA.original[id].Number;
          }

          if (rowB.original[id] && rowB.original[id].Number) {
            valB = rowB.original[id].Number;
          }

          return valA.localeCompare(valB);
        },
        Cell: cellComponentWs,
      },
      {
        Header: 'Installation date',
        accessor: 'InstallationDate',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Decommission date',
        accessor: 'DecommissionDate',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Status',
        accessor: 'SensorStatusName',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        id: 'SEActionsId',
        disableSortBy: true,
        Cell: actionMenu,
      },
    ],
    [isLarge, isMedium],
  );

  return (
    <Card border="light" className="page-card">
      <Card.Header>
        <Row className="mt-4"></Row>
        {crud.getHeader()}
      </Card.Header>
      <Card.Body>
        <Row>
          <Col className="col-6 pb-2">
            <input
              className="form-control float-left"
              placeholder="Search..."
              id="user_text_searchSensor"
              type="text"
              value={searchSensor}
              onChange={(e) => setSearchSensor(e.target.value)}
            ></input>
          </Col>
          <Col className="col-9"></Col>
        </Row>
        <Row>
          <Col className="col-12">
            <Table
              columns={columns}
              data={filteredSensorData}
              fetchData={() => {}}
              loading={loading}
              search=""
              defaultSortBy={'Id'}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SensorAssociatedModelTable;
